import { render, staticRenderFns } from "./welcome-screen-additional-info.vue?vue&type=template&id=b4994d92"
import script from "./welcome-screen-additional-info.vue?vue&type=script&lang=js"
export * from "./welcome-screen-additional-info.vue?vue&type=script&lang=js"
import style0 from "./welcome-screen-additional-info.vue?vue&type=style&index=0&id=b4994d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog,VIcon,VImg})
